import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type { FanguardApiContractsSystemSettingsCorsOriginsModel } from 'src/api/generated';

export const SYSTEM_URI = 'system';
export const CORS_ORIGINS_URI = `${SYSTEM_URI}/cors-origins`;

export const systemQueries = createQueryKeys(SYSTEM_URI, {
  all: null,
  corsOrigins: {
    queryKey: ['cors-origins'] as const,
    queryFn: async () => {
      const response = await get<FanguardApiContractsSystemSettingsCorsOriginsModel>({ uri: CORS_ORIGINS_URI });
      return response.data.origins ?? [];
    },
  },
});
